/* MSC MOD */
window.msc = window.msc || {};
msc.currentRate = window.Shopify.currency.rate;
msc.canAddFreeGiftOnCartUpdate = false
msc.freeGiftThreshold = false
msc.freeGiftFunction = function () {
    // console.log('freeGiftFunction');
    if (Shopify.designMode) {
        return
    }
    if (msc.freeGiftItem.length <= 0) {
        return
    }
    let _isValidDate = false;
    let cart_threshold = -1
    msc.freeGiftItem.forEach(settings => {
        let start_date_string = settings.time_start;
        let end_date_string = settings.time_end;
        let isValidDate = true;
        if (start_date_string || end_date_string) {
            const now = new Date();
            if (start_date_string) {
                const full_date_s = start_date_string.split(' ');
                let times_s = [0, 0, 0];
                const date_s = full_date_s[0].split('-');
                if (full_date_s.length === 2) {
                    times_s = full_date_s[1].split(':');
                }
                try {
                    const startDate = new Date(date_s[2], date_s[0] - 1, date_s[1], times_s[0], times_s[1], times_s[2]);
                    isValidDate = isValidDate && (now >= startDate);
                } catch (e) {
                    //console.error(e);
                }
            }
            if (end_date_string) {
                const full_date_t = end_date_string.split(' ');
                let times_t = [0, 0, 0];
                const date_t = full_date_t[0].split('-');
                if (full_date_t.length === 2) {
                    times_t = full_date_t[1].split(':');
                }
                try {
                    const endDate = new Date(date_t[2], date_t[0] - 1, date_t[1], times_t[0], times_t[1], times_t[2]);
                    isValidDate = isValidDate && (now <= endDate);
                } catch (e) {
                    //console.error(e);
                }
            }
        }
        if (msc.currentRate !== -1) {
            settings.cart_threshold *= msc.currentRate;
        }
        cart_threshold = settings.cart_threshold
        _isValidDate = _isValidDate || isValidDate
    })
    msc.canAddFreeGiftOnCartUpdate = _isValidDate
    msc.freeGiftThreshold = cart_threshold
    if (_isValidDate) {
        // document.addEventListener('cart:updated', function (evt) {
        //     // console.log('cart:updated');
        //     // console.log(evt);
        //     // msc._mscAddToCart(settings, evt.detail.cart);
        //     msc.freeGiftEvaluate(evt.detail.cart)
        // });
        document.addEventListener('ajaxProduct:added', function (evt) {
            // console.log('ajaxProduct:added');
            // console.log(evt);
            // msc._mscAddToCart(settings);
            fetch(window.Shopify.routes.root + "cart.js")
                .then((response) => {
                    return (typeof response.json === "function") ? response.json() : response
                })
                .then((cart) => {
                    msc.freeGiftEvaluate(cart)
                });
        });
        // msc._mscAddToCart(settings);
        if (document.body.classList.contains('template-cart')) {
            // console.log('template-cart gift');
            let containerItems = document.querySelector('.cart-cart__items');
            let cartProductGiftAction = (containerItems && typeof containerItems.dataset.cartProductGift !== "undefined") ? containerItems.dataset.cartProductGift : '';
            msc.freeGiftMarkup(containerItems, cartProductGiftAction);
            msc.freeGiftBind(cartProductGiftAction)
        }
    }
}

msc.freeGiftEvaluate = (cart) => {
    let cartProductGift = ''
    if (typeof cart.attributes.product_gift !== 'undefined') {
        cartProductGift = cart.attributes.product_gift;
    }
    let cart_total = msc.calculateNewCartTotal(cart, false)
    // console.log(cart.total_price, cart_total, msc.freeGiftThreshold)
    // console.log((cart_total) < msc.freeGiftThreshold)
    if (cart_total < msc.freeGiftThreshold) {
        // console.log('under cart_threshold')
        msc._removeFreeGift().then(response => {
            // console.log('under cart_threshold remove')
            if (msc.currentGiftPlaceholder != null && msc.currentGiftPlaceholder.classList.contains('loading')) {
                msc.currentGiftPlaceholder.classList.remove('loading')
                msc.currentGiftPlaceholder.classList.add('active')
                msc.currentGiftPlaceholder = null
            }
            document.dispatchEvent(new CustomEvent('cart:build'))
        })
    } else {
        // console.log('_addManualFreeGift')
        msc._addManualFreeGift(cartProductGift)
    }
}
msc._mscAddToCartWCart = function (settings, cart) {
    let cartItems = cart.items,
        qtyInTheCart = 0,
        cartUpdates = 0,
        _variant_id = settings.variant_id + "",
        cartAttribute = '',
        params = {},
        cartProductGift = '',
        qtyInTheCartGeneral = 0,
        priceToRemove = 0;
    if ((cart.total_price - priceToRemove) < settings.cart_threshold || settings.cart_threshold === -1) {
        return;
    }

    for (let i = 0; i < cartItems.length; i++) {
        if (cartItems[i].id + "" === settings.variant_id + "") {
            qtyInTheCartGeneral += cartItems[i].quantity;
            if (cartItems[i].final_line_price === 0) {
                qtyInTheCart = cartItems[i].quantity;
                break;
            }
        }
    }

    // check gift_card
    var totalGiftCard = 0;
    var removeForGiftCard = false;
    for (let i = 0; i < cartItems.length; i++) {
        if (!cartItems[i].gift_card) {
            continue;
        }
        totalGiftCard += cartItems[i].final_line_price;
    }
    if (totalGiftCard > 0) {
        var new_cart_total_price = cart.total_price - totalGiftCard;
        if (new_cart_total_price < settings.cart_threshold) {
            if (qtyInTheCart <= 0) {
                return;
            }
            removeForGiftCard = true
        }
    }
    // console.log('qtyInTheCart ' + qtyInTheCart);
    if (removeForGiftCard || qtyInTheCart > 1) {
        cartUpdates = Math.max(0, qtyInTheCartGeneral - 1);
        // cartAttribute = _variant_id;
    } else if (qtyInTheCart === 1) {
        return;
    } else if (qtyInTheCart < 1) {
        cartUpdates = Math.max(1, qtyInTheCartGeneral + 1)
        // cartAttribute = _variant_id;
    } else {
        return;
    }
    let dataUpdates = {}
    dataUpdates['updates[' + _variant_id + ']'] = cartUpdates
    // console.log('Add to cart gift ' + (new URLSearchParams(dataUpdates)).toString())
    fetch(window.Shopify.routes.root + 'cart/update.js?' + (new URLSearchParams(dataUpdates)).toString(), {method: 'POST'})
        .then(response => {
            return (typeof response.json === "function") ? response.json() : response
        })
        .then(data => {
            document.dispatchEvent(new CustomEvent('cart:build'));
        })
        .catch((error) => {
            console.error('Error:', error);
        });
}
msc._mscAddToCart = async function (settings, cart) {
    // console.log('_mscAddToCart');
    if (!cart) {
        // console.log('data cart 2');
        let response = await fetch(window.Shopify.routes.root + "cart.js")
        cart = await response
        if (typeof cart.json === "function") {
            cart = await cart.json()
        }
    }
    msc._mscAddToCartWCart(settings, cart);
}
msc._removeFreeGift = async function () {
    // cart__items
    // cart-cart__items
    // console.log('start delete old gift')
    let gift_id = null
    document.querySelectorAll('.cart__item__product_gift').forEach(elem => {
        // console.log(elem.dataset.key)
        gift_id = elem.dataset.key
    })
    if (gift_id == null) {
        // console.log(gift_id)
        return
    }
    let productGiftId = gift_id.split(":")
    let dataUpdates = {'attributes[product_gift]': ""}
    dataUpdates['updates[' + productGiftId[0] + ']'] = 0
    // https://www.mysecretcase.com/cart/change?id=40215947641015:686c2ad5ab7c4dcd8333a4660bcbd125&quantity=0
    // console.log('_removeFreeGift ' + (new URLSearchParams(dataUpdates)).toString());
    let response = await fetch(window.Shopify.routes.root + 'cart/update.js?' + (new URLSearchParams(dataUpdates)).toString(), {method: 'POST'})
    let data = await response
    if(typeof data.json === "function") {
        data = await data.json()
    }
    return data
}
msc._addManualFreeGift = async function (variant_id) {
    if (typeof variant_id === "undefined") {
        variant_id = ""
    }
    // console.log('add manual gift ' + (new URLSearchParams({'attributes[product_gift]': variant_id})).toString())
    let response = await fetch(window.Shopify.routes.root + 'cart/update.js?' + (new URLSearchParams({'attributes[product_gift]': variant_id})).toString(), {method: 'POST'});
    let cart = await response
    if (typeof cart.json === "function") {
        cart = await cart.json()
    }
    // console.log('_addManualFreeGift update done')
    if (!msc.freeGiftItem || msc.freeGiftItem.length <= 0 || variant_id === "") {
        return;
    }
    // console.log('_addManualFreeGift add')
    msc.freeGiftItem.forEach(fgItem => {
        if (fgItem.variant_id + "" === variant_id + "") {
            msc._mscAddToCart(fgItem);
        }
    });
}
msc.currentGiftPlaceholder = null
msc.freeGiftBind = function () {
    document.querySelectorAll('.cart__item__gift__placeholder').forEach(item => {
        item.addEventListener('click', event => {
            // console.log(event.target.closest('.cart__item__gift__placeholder').classList)
            if (event.target.closest('.cart__item__gift__placeholder').classList.contains('active') || document.querySelector('.cart__item__gift__placeholder.loading')) {
                return
            }
            document.querySelector('.cart__item__gift__placeholder.active').classList.remove('active')
            msc.currentGiftPlaceholder = event.target.closest('.cart__item__gift__placeholder')
            msc.currentGiftPlaceholder.classList.add('loading')
            msc._removeFreeGift().then(response => {
                    // console.log('then remove')
                    // console.log(typeof msc.currentGiftPlaceholder.dataset.variant_id !== "undefined", typeof msc.currentGiftPlaceholder.dataset.variant_id)
                    if (typeof msc.currentGiftPlaceholder.dataset.variant_id !== "undefined") {
                        msc._addManualFreeGift(msc.currentGiftPlaceholder.dataset.variant_id).then(response => {
                            // msc.currentGiftPlaceholder.classList.remove('loading')
                            // msc.currentGiftPlaceholder.classList.add('active')
                            // msc.currentGiftPlaceholder = null
                            // console.log('manual add gift')
                        })
                    } else {
                        if (msc.currentGiftPlaceholder != null && msc.currentGiftPlaceholder.classList.contains('loading')) {
                            msc.currentGiftPlaceholder.classList.remove('loading')
                            msc.currentGiftPlaceholder.classList.add('active')
                            msc.currentGiftPlaceholder = null
                            document.dispatchEvent(new CustomEvent('cart:build'))
                        }
                    }
                }
            )

        })
    })
}
msc.freeGiftMarkupDone = false;
msc.freeGiftMarkup = function (items, productGift) {
    if (msc.freeGiftMarkupDone || !msc.freeGiftItem || msc.freeGiftItem.length <= 0) {
        return items;
    }
    let can_insert = false
    let product_to_display = []
    let cart_threshold = -1
    msc.freeGiftItem.forEach(fgItem => {
        if (msc.validateDate(fgItem.time_start, fgItem.time_end) && fgItem.inventory > 0) {
            can_insert = true
            product_to_display.push(fgItem.index)
            cart_threshold = cart_threshold < fgItem.cart_threshold ? fgItem.cart_threshold : cart_threshold
        }
    });
    /*
    (items.dataset.cartSubtotal < fgItem.cart_threshold || fgItem.cart_threshold === -1 || productGift === 'manual_removed')
     */
    if (can_insert) {
        let giftAdded = null
        // display placeholder
        let placeholder = document.getElementById('product_gift_all').cloneNode(true);
        placeholder.classList.remove('hide');
        placeholder.id = 'product_gift_all_cloned';
        if (cart_threshold === -1) {
            cart_threshold = 0;
        }
        if (items.dataset.cartSubtotalNoGiftcard >= cart_threshold && cart_threshold !== -1) {
            placeholder.querySelector('.gift__placeholder').classList.add('hide');
        } else {
            let cartSubTotal = (items.dataset.cartSubtotalNoGiftcard === undefined) ? (items.dataset.cartSubtotal === undefined ? 0 : items.dataset.cartSubtotal) : items.dataset.cartSubtotalNoGiftcard
            placeholder.innerHTML = placeholder.innerHTML.replaceAll("##money##", theme.Currency.formatMoney(cart_threshold - cartSubTotal, theme.settings.moneyFormat));
            giftAdded = false
        }
        product_to_display.forEach(prodIdx => {
            placeholder.querySelector('.cart__item__gift__' + prodIdx).classList.remove('hide')
        })
        // console.log('gift ' + productGift)
        let gift_id = (productGift !== null && productGift !== "") ? productGift : null
        // console.log('gift ' + gift_id)
        // console.log(typeof gift_id, gift_id)
        if (gift_id !== null && gift_id !== "") {
            let placeholder_gift = placeholder.querySelector('.cart__item__gift__placeholder[data-variant_id="' + gift_id + '"]')
            if (placeholder_gift) {
                placeholder.querySelector('.cart__item__gift__placeholder.active').classList.remove('active')
                placeholder_gift.classList.add('active')
                giftAdded = (giftAdded === null)
            }
        }
        if (!theme.settings.flashSalesHideGift || !msc.flashSalesMarkupDisplayed || giftAdded === true) {
            items.insertBefore(placeholder, items.lastChild);
        }
    }
    msc.freeGiftMarkupDone = true;
    return items;
}
msc.setCookie = function (name, value, days) {
    let expires = "";
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
msc.getCookie = function (name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}
msc.validateDate = function (from, to) {
    var isValidDate = true;
    var start_date_string = from;
    var end_date_string = to;
    if (start_date_string || end_date_string) {
        var now = new Date();
        if (start_date_string) {
            var full_date_s = start_date_string.split(' ');
            var times_s = [0, 0, 0];
            var date_s = full_date_s[0].split('-')
            if (full_date_s.length === 2) {
                times_s = full_date_s[1].split(':');
            }
            try {
                var startDate = new Date(date_s[2], date_s[0] - 1, date_s[1], times_s[0], times_s[1], times_s[2]);
                isValidDate = isValidDate && (now >= startDate);
            } catch (e) {
                //console.error(e);
            }
        }
        if (end_date_string) {
            var full_date_t = end_date_string.split(' ');
            var times_t = [0, 0, 0];
            var date_t = full_date_t[0].split('-')
            if (full_date_t.length === 2) {
                times_t = full_date_t[1].split(':');
            }
            try {
                var endDate = new Date(date_t[2], date_t[0] - 1, date_t[1], times_t[0], times_t[1], times_t[2]);
                isValidDate = isValidDate && (now <= endDate);
            } catch (e) {
                //console.error(e);
            }
        }
    }
    return isValidDate;
}
msc.openPushbar = function (not_ready) {
    if (document.querySelectorAll('.sales-bar:not(.hidden) .sales-bar-close').length <= 0) {
        return;
    }
    var _cookie_str = "_pbs"; // push_bar_state
    var _self = document.querySelector('.sales-bar:not(.hidden) .sales-bar-close .sales-bar-close--btn');
    var _pushbar = document.querySelector('.sales-bar:not(.hidden)');
    var cookie_val = msc.getCookie(_cookie_str);


    if (not_ready) {
        if (cookie_val == 'down') {
            cookie_val = "up";
        } else {
            cookie_val = 'down';
        }
        msc.setCookie(_cookie_str, cookie_val);
    }
    if (cookie_val == "down") {
        _self.classList.remove('open');
        _self.classList.add('up-bar');
        _pushbar.classList.add('down');
    } else {
        _self.classList.remove('up-bar');
        _self.classList.add('open')
        _pushbar.classList.remove('down');
    }

};
msc.removeCOD = function () {
    // contanti alla consegna
    fetch(window.Shopify.routes.root + "cart.js")
        .then((response) => {
            return (typeof response.json === "function") ? response.json() : response
        })
        .then((cart) => {
            let cartItems = cart.items;
            let qtyInTheCart = 0,
                cartUpdates = {},
                variant_id = 40305680810167;
            // FIXME add configuration

            if (cartItems.length <= 0) {
                return;
            }

            for (let i = 0; i < cartItems.length; i++) {
                if (cartItems[i].id === variant_id) {
                    qtyInTheCart = cartItems[i].quantity;
                    break;
                }
            }

            if ((cartItems.length >= 1) && (qtyInTheCart > 0)) {
                cartUpdates[variant_id] = 0
            } else {
                return;
            }
            const data = {updates: cartUpdates};
            // console.log('Remove COD')
            fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST', // or 'PUT'
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            })
                .then(response => {
                    return (typeof response.json === "function") ? response.json() : response
                })
                .then(data => {
                    document.dispatchEvent(new CustomEvent('cart:build'));
                })
                .catch((error) => {
                    console.error('Error:', error);
                });

        });
}
msc.removeNLMessage = function () {
    var el = document.querySelector('.footer__newsletter .note');
    if (el) {
        setTimeout(function () {
            el.classList.add("hide");
        }, 10000);
    }
}
msc.newsletterFormValidator = function () {
    $('.footer__newsletter .btn').on('click', function (e) {
        if ($('.newsletter-checkbox:checked').length <= 0) {
            e.preventDefault();
            $('.newsletter-checkbox-error').css('display', 'block');
            $('.custom-newsletter-checkmark').css('border-color', "#ff6d6d");
        }
    });
    $('.newsletter-checkbox-text').on('click', function (e) {
        if (document.querySelector('.newsletter-checkbox').checked) {
            document.querySelector('.newsletter-checkbox').checked = false;
        } else {
            document.querySelector('.newsletter-checkbox').checked = true;
            $('.newsletter-checkbox-error').css('display', 'hide');
            $('.custom-newsletter-checkmark').css('border-color', "#ccc");
        }
    });
    $('.newsletter-checkbox').on('click', function (e) {
        if (document.querySelector('.newsletter-checkbox').checked) {
            $('.newsletter-checkbox-error').css('display', 'hide');
            $('.custom-newsletter-checkmark').css('border-color', "#ccc");
        }
    });
}
msc.gtmSetPosition = function () {
    let productsGrid = document.querySelectorAll('.product-grid')
    if (productsGrid) {
        productsGrid.forEach((gridElement) => {
            let allProducts = gridElement.querySelectorAll('.grid-item.grid-product')
            if (allProducts) {
                allProducts.forEach((element, index) => {
                    element.dataset.gtmPosition = index + 1
                })
            }
        })
    }
}
msc.flashSalesResetCartData = async (flashIndex, cart, custom = 0) => {
    //console.log('reset cart flashSalesResetCartData')
    //console.log(flashIndex, cart)
    let totalCounter = !isNaN(cart?.attributes?.flashProductCounter) ? parseInt(cart?.attributes?.flashProductCounter) : custom
    const data_update = {}

    if (flashIndex > 0) {
        data_update['attributes[flashProductHandle' + flashIndex + ']'] = "";
        data_update['attributes[flashProductVariantId' + flashIndex + ']'] = "";
        data_update['attributes[flashEndDate' + flashIndex + ']'] = "";
        data_update['attributes[flashThreshold' + flashIndex + ']'] = "";
        data_update['attributes[flashStatus' + flashIndex + ']'] = "";
        data_update['attributes[flashProductCounter]'] = totalCounter - 1;
        if (flashIndex != totalCounter) {
            for (let i = totalCounter; i > flashIndex; i--) {
                data_update['attributes[flashProductHandle' + (i - 1) + ']'] = cart.attributes['flashProductHandle' + i];
                data_update['attributes[flashProductVariantId' + (i - 1) + ']'] = cart.attributes['flashProductVariantId' + i];
                data_update['attributes[flashEndDate' + (i - 1) + ']'] = cart.attributes['flashEndDate' + i];
                data_update['attributes[flashThreshold' + (i - 1) + ']'] = cart.attributes['flashThreshold' + i];
                data_update['attributes[flashStatus' + (i - 1) + ']'] = cart.attributes['flashStatus' + i];
            }
        }
    } else {
        for (let i = 0; i <= totalCounter; i++) {
            data_update['attributes[flashProductHandle' + i + ']'] = "";
            data_update['attributes[flashProductVariantId' + i + ']'] = "";
            data_update['attributes[flashEndDate' + i + ']'] = "";
            data_update['attributes[flashThreshold' + i + ']'] = "";
            data_update['attributes[flashStatus' + i + ']'] = "";
        }
        data_update['attributes[flashProductCounter]'] = "";
    }
    //console.log(data_update)
    // console.log('Reset flash sales data')
    let response = await fetch(window.Shopify.routes.root + 'cart/update.js?' + (new URLSearchParams(data_update)).toString(), {method: 'POST'})
    let data = await response
    if(typeof data.json === "function") {
        data = await data.json();
    }
    return data
}
msc.flashSalesItems = []
msc.flashSalesInit = () => {
    if (Shopify.designMode) {
        return
    }
    //console.log('flash sales init')
    // cart page: add markup
    if (document.body.classList.contains('template-cart')) {
        // console.log('template-cart flash');
        let containerItems = document.querySelector('.cart-cart__items');
        msc.flashSalesMarkup(containerItems);
    }
    // add custom add to cart button
    let fakeAdd = document.querySelector('#fake-add-to-cart')
    if (fakeAdd) {
        msc.flashSalesProductAddButton(fakeAdd)
    }
    // document.addEventListener('cart:updated', msc.flashSalesCartUpdateBind.bind(this))
    document.addEventListener('ajaxProduct:added', function (evt) {
        fetch(window.Shopify.routes.root + "cart.js")
            .then((response) => {
                return (typeof response.json === "function") ? response.json() : response
            })
            .then((cart) => {
                msc.flashSalesCartUpdateBind({'detail': {'cart': cart}})
            });
    })
    msc.flashSalesCheckCartData()
}
msc.flashSalesMarkupDone = false
msc.flashSalesMarkupDisplayed = false
msc.flashSalesMarkup = function (items) {
    msc.flashSalesMarkupDisplayed = false
    if (msc.flashSalesMarkupDone) {
        return items
    }
    // display placeholder
    let placeholders = items.querySelectorAll('.promo-active-disabled');
    if (!placeholders) {
        return items
    }
    const cartThresholds = items.dataset?.cartProductFlashThreshold.split(',')
    const cartSubTotal = items.dataset.cartSubtotalFlash === undefined ? 0 : items.dataset.cartSubtotalFlash
    placeholders.forEach((placeholder, index) => {
        let cart_threshold = cartThresholds[index] * window.Shopify.currency.rate
        // console.log(cart_threshold,cartSubTotal)
        let difference = cart_threshold - cartSubTotal
        if (difference > 0) {
            placeholder.innerHTML = placeholder.innerHTML.replaceAll("##money##", theme.Currency.formatMoney(difference, theme.settings.moneyFormat));
            placeholder.classList.remove('hide');
            msc.flashSalesMarkupDisplayed = true
        }
    })

    msc.flashSalesMarkupDone = true
    return items;
}
msc.flashSalesProductAddButton = (fakeAdd) => {
    fakeAdd.addEventListener('click', (event) => {
        event.preventDefault()
        event.stopPropagation()
        event.stopImmediatePropagation()
        let target_element = event.target;
        if (!event.target.classList.contains('btn--full')) {
            target_element = target_element.closest('.btn--full')
        }
        if(target_element.classList.contains('btn--loading')) {
            return
        }
        target_element.classList.add('btn--loading')
        let cart_threshold = (target_element.dataset.flashThreshold * 100) * window.Shopify.currency.rate;
        let product_handle = target_element.dataset.handle
        let flashEndDate = target_element.dataset.flashEndDate
        // let product_price = target_element.dataset.price
        let variant_id = 0
        if (document.querySelectorAll('.product-single__variants')) {
            variant_id = document.querySelectorAll('.product-single__variants')[0].value
        }
        // let dataUpdate = {
        //     'attributes[flashProductHandle]': product_handle,
        //     'attributes[flashProductVariantId]': variant_id,
        //     'attributes[flashEndDate]': flashEndDate,
        //     'attributes[flashThreshold]': cart_threshold,
        //     'attributes[flashStatus]': "show_disclaimer",
        //     'attributes[flashProductCounter]': 1
        // }
        fetch(window.Shopify.routes.root + "cart.js")
            .then((response) => {
                return (typeof response.json === "function") ? response.json() : response
            })
            .then((cart) => {
                let cartItems = cart.items,
                    priceInTheCart = 0,
                    totalFlash = isNaN(cart?.attributes?.flashProductCounter) ? 0 : parseInt(cart?.attributes?.flashProductCounter),
                    index = 0,
                    allFlashProdsVariantIds = [];

                if (totalFlash >= theme.settings.maxMySecretPromoProds) {
                    document.getElementById('mysecretpromo-alert-disclaimer').classList.remove('hide');
                    target_element.classList.remove('btn--loading');
                    return
                }

                for (let i = 1; i <= totalFlash; i++) {
                    if (parseInt(cart?.attributes['flashProductVariantId' + i]) === parseInt(variant_id)) {
                        index = i;
                    }
                    allFlashProdsVariantIds.push(cart?.attributes['flashProductVariantId' + i])
                }
                if (index === 0) {
                    totalFlash += 1
                    index = totalFlash
                }
                //console.log('flashProductCounter ' + totalFlash)
                let dataUpdate = {
                    'attributes[flashProductCounter]': totalFlash
                }
                dataUpdate['attributes[flashProductHandle' + index + ']'] = product_handle
                dataUpdate['attributes[flashProductVariantId' + index + ']'] = variant_id
                dataUpdate['attributes[flashEndDate' + index + ']'] = flashEndDate
                dataUpdate['attributes[flashThreshold' + index + ']'] = cart_threshold
                dataUpdate['attributes[flashStatus' + index + ']'] = "show_disclaimer"
                allFlashProdsVariantIds.push(variant_id)
                // console.log(cart)
                if (cart_threshold >= cart.total_price) {
                    // console.log('Update flash sales data ' + (new URLSearchParams(dataUpdate)).toString())
                    return fetch(window.Shopify.routes.root + 'cart/update.js?' + (new URLSearchParams(dataUpdate)).toString(), {method: 'POST'})
                        .then((response) => {
                            return (typeof response.json === "function") ? response.json() : response
                        })
                        .then(data => {
                            document.dispatchEvent(new CustomEvent('cart:build'));
                            document.dispatchEvent(new CustomEvent('cart:open'));
                            target_element.classList.remove('btn--loading')
                        })
                }

                for (let i = 0; i < cartItems.length; i++) {
                    if (allFlashProdsVariantIds.includes(cartItems[i].id) || cartItems[i].gift_card == true) {
                        // priceInTheCart += cartItems[i].price * cartItems[i].quantity;
                        priceInTheCart += cartItems[i].final_line_price;
                    }
                }
                if (cart_threshold >= (cart.total_price - priceInTheCart)) {
                    // console.log('Update flash sales data ' + (new URLSearchParams(dataUpdate)).toString())
                    return fetch(window.Shopify.routes.root + 'cart/update.js?' + (new URLSearchParams(dataUpdate)).toString(), {method: 'POST'})
                        .then((response) => {
                            return (typeof response.json === "function") ? response.json() : response
                        })
                        .then(data => {
                            document.dispatchEvent(new CustomEvent('cart:build'))
                            document.dispatchEvent(new CustomEvent('cart:open'))
                            target_element.classList.remove('btn--loading')
                        })
                }
                dataUpdate['attributes[flashStatus' + index + ']'] = "added"
                // console.log('Update flash sales data ' + (new URLSearchParams(dataUpdate)).toString())
                return fetch(window.Shopify.routes.root + 'cart/update.js?' + (new URLSearchParams(dataUpdate)).toString(), {method: 'POST'})
                    .then((response) => {
                        return (typeof response.json === "function") ? response.json() : response
                    })
                    .then(data => {
                        // console.log('trigger add click')
                        target_element.classList.remove('btn--loading')
                        document.querySelector('[data-add-to-cart]').click()
                        // document.dispatchEvent(new CustomEvent('msc:flashsales:added'))
                        // document.dispatchEvent(new CustomEvent('cart:updated', {
                        //     detail: {
                        //         cart: cart
                        //     }
                        // }))
                    })
            });
    })
}
msc.flashSalesAddProduct = async (flashIndex, variant_id, quantity, flash_status) => {
    let cartUpdates = {}
    cartUpdates[variant_id] = quantity
    let data_update = {}
    data_update['attributes[flashStatus' + flashIndex + ']'] = flash_status
    data_update['updates[' + variant_id + ']'] = quantity
    //console.log('Flash sales add ' + (new URLSearchParams(data_update)).toString())
    let response = await fetch(window.Shopify.routes.root + 'cart/update.js?' + (new URLSearchParams(data_update)).toString(), {method: 'POST'})
    let cartStatus = await response
    if (typeof cartStatus.json === "function") {
        cartStatus = await cartStatus.json();
    }
    //console.log(cartStatus)
    document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: {
            cart: cartStatus
        }
    }))
}
msc.calculateNewCartTotal = (cart, flashSales = true, freeGift = true) => {
    let cart_total = cart.total_price
    let cartProductGift = ''
    if (typeof cart.attributes.product_gift !== 'undefined') {
        cartProductGift = cart.attributes.product_gift;
    }
    if (cart.items.length > 0) {
        cart.items.forEach(item => {
            if (flashSales) {
                let counter = parseInt(cart.attributes.flashProductCounter)
                for (let i = 1; i <= counter; i++) {
                    if (parseInt(item.id) === parseInt(cart.attributes['flashProductVariantId' + i])) {
                        cart_total -= item.final_line_price
                        return
                    }
                }
            }
            if (freeGift && cartProductGift !== '' && item.id + "" === cartProductGift + "" && item.final_line_price !== 0) {
                cart_total -= item.final_line_price
                return
            }
            if (item.gift_card) {
                cart_total -= item.final_line_price;
                return
            }
        })
    }
    return cart_total
}
msc.flashSalesCartUpdateBind = async (evt) => {
    //console.log('change cart')
    const cart = evt?.detail?.cart,
        cart_total = msc.calculateNewCartTotal(cart)
    let counter = !isNaN(cart?.attributes?.flashProductCounter) ? parseInt(cart?.attributes?.flashProductCounter) : 0
    for (let i = 1; i <= counter; i++) {
        if (typeof cart?.attributes['flashStatus' + i] === "undefined") {
            return
        }
        let found = false
        let cart_threshold_settings = !isNaN(cart.attributes['flashThreshold' + i]) ? parseInt(cart.attributes['flashThreshold' + i]) : 0
        if (cart.items.length > 0) {
            cart.items.forEach(item => {
                if (parseInt(item.id) === parseInt(cart.attributes['flashProductVariantId' + i])) {
                    //console.log('found flash sales prod ' + cart.attributes['flashProductVariantId' + i])
                    found = true
                    return
                }
            })
        }

        //console.log(found, cart.attributes['flashStatus' + i])
        //console.log(cart_threshold_settings >= cart_total, cart_threshold_settings, cart_total)
        let now = new Date(),
            flashEndDate;
        try {
            flashEndDate = new Date(cart.attributes['flashEndDate' + i])
        } catch (e) {
            flashEndDate = new Date()
            flashEndDate.setDate(now.getDate() - 1);
        }

        if (!found && (cart.attributes['flashStatus' + i] === "added" || now > flashEndDate)) {
            // console.log('not found reset')
            return msc.flashSalesResetCartData(i, cart)
        } else if (!found && cart_threshold_settings < cart_total && (cart.attributes['flashStatus' + i] === "removed" || cart.attributes['flashStatus' + i] === "show_disclaimer")) {
            // console.log('re add prod')
            return msc.flashSalesAddProduct(i, parseInt(cart.attributes['flashProductVariantId' + i]), 1, "added")
        } else if (found && cart_threshold_settings >= cart_total && (cart.attributes['flashStatus' + i] === "added" || cart.attributes['flashStatus' + i] === "show_disclaimer")) {
            //console.log('remove prod ' + cart.attributes['flashProductVariantId' + i])
            return msc.flashSalesAddProduct(i, parseInt(cart.attributes['flashProductVariantId' + i]), 0, "removed")
        } else {
            // console.log('trigger cart:build', found, cart.attributes.flashStatus)
            document.dispatchEvent(new CustomEvent('cart:build'))
        }
    }
}
msc.flashSalesCheckCartData = () => {
    // console.log('check date')
    fetch(window.Shopify.routes.root + "cart.js")
        .then((response) => {
            return (typeof response.json === "function") ? response.json() : response
        })
        .then((cart) => {
            msc.flashSalesCartUpdateBind({'detail': {'cart': cart}})
        });
}


// Start Code to execute
setTimeout(function () {

    let el = document.querySelector('.jdgm-widget-fake .jdgm-write-rev-link');
    if (el) {
        el.addEventListener('click', function (event) {
            document.querySelector('.jdgm-revs-tab-btn').click();
        });
    }
    if (document.querySelectorAll('.sales-bar-close--btn').length > 0) {
        document.querySelectorAll('.sales-bar-close--btn').forEach((elem) => {
            elem.addEventListener('click', function (e) {
                e.preventDefault();
                msc.openPushbar(true);
            });
        })
    }
    let anchorDescription = document.querySelectorAll('.collection-description a');
    if (anchorDescription) {
        anchorDescription.forEach(function (anchorElement) {
            let jump = anchorElement.getAttribute('href');
            if (jump.startsWith('#')) {
                anchorElement.addEventListener('click', function (e) {
                    e.preventDefault();
                    let _elementId = this.getAttribute('href').substr(1)
                    let _element = document.getElementById(_elementId);
                    window.scrollTo(_element.offsetLeft, _element.offsetTop - 150);
                })
            }
        });
    }
    // remove newsletter message
    msc.removeNLMessage();
    // validator newsletter footer
    msc.newsletterFormValidator();

    if (typeof window.theme !== "undefined" &&
        typeof window.theme.settings !== "undefined" &&
        typeof window.theme.settings.request_locale_code !== "undefined") {
        const footerAccountLinks = document.querySelectorAll('.footer__menu a[href*="account"]')
        if (footerAccountLinks && footerAccountLinks.length > 0) {
            footerAccountLinks.forEach((el, i) => {
                el.href = el.href.replace("/account", "/" + window.theme.settings.request_locale_code + "/account")
            })
        }

    }
});

msc.openPushbar(false);

// remove selected "in contanti alla consegna"
try {
    if (typeof window.localStorage === "undefined") {
        if (msc.getCookie('_ccSeletected')) {
            msc.setCookie('_ccSeletected', true, -1);
        }
    } else {
        if (window.localStorage.getItem('_ccSeletected')) {
            window.localStorage.removeItem('_ccSeletected');
        }
    }
} catch (e) {
    //console.error('error _ccSelected');
}

msc.removeCOD()
msc.gtmSetPosition()

// Hide pushbar on cart open
document.addEventListener('CartDrawer:open', (evt) => {
    document.getElementById('shopify-section-footer-bar').classList.add('hide')
})
document.querySelectorAll('.site-nav__close-cart .js-close-header-cart').forEach(element => {
    element.addEventListener('click', (evt) => {
        document.getElementById('shopify-section-footer-bar').classList.remove('hide')
    })
})
// msc.flashSalesResetCartData(0, null, 5)
msc.flashSalesInit()
// TODO: variantChange
document.addEventListener('cart:updated', function (evt) {
    // console.log('cart:updated');
    // console.log(evt);
    msc.flashSalesCartUpdateBind(evt).then(() => {
        if (msc.canAddFreeGiftOnCartUpdate) {
            msc.freeGiftEvaluate(evt.detail.cart)
        }
    })
});
/* MSC MOD END */
